var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import Box from "../box/Box";
import { withTheme } from "styled-components";
import { themeGet } from "@styled-system/theme-get";
function Icon(props, ref) {
    var Component = props.icon, iconStyle = props.iconStyle, color = props.color, size = props.size, style = props.style, _a = props.verticalAlign, verticalAlign = _a === void 0 ? "middle" : _a, theme = props.theme, _b = props.type, type = _b === void 0 ? "button" : _b, ariaLabel = props.ariaLabel, rest = __rest(props, ["icon", "iconStyle", "color", "size", "style", "verticalAlign", "theme", "type", "ariaLabel"]);
    var iconProps = {
        style: iconStyle,
        color: color ? themeGet("colors." + color, color)(props) : theme.reactIconBase.color,
        size: size ? size : theme.reactIconBase.size,
    };
    var styles = __assign({ overflow: "hidden", verticalAlign: verticalAlign }, style);
    var extraProps = {};
    if (props.onClick) {
        styles = __assign(__assign({}, styles), { cursor: "pointer", background: "none", border: "none" });
        extraProps = {
            as: "button",
            type: type,
            "aria-label": ariaLabel,
            role: "button",
        };
    }
    return (React.createElement(Box, __assign({ ref: ref, display: "inline-flex", justifyContent: "center", alignItems: "center", p: 0, role: "img", style: styles }, rest, extraProps),
        React.createElement(Component, __assign({}, iconProps))));
}
export default withTheme(React.forwardRef(Icon));
//# sourceMappingURL=Icon.js.map